import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// eslint-disable-next-line import/no-unresolved
import { Analytics } from '@vercel/analytics/react';
import Main from './layouts/Main'; // fallback for lazy pages
import './static/css/main.scss'; // All of our styles

const { PUBLIC_URL } = process.env;

// Every route - we lazy load so that each page can be chunked
// NOTE that some of these chunks are very small. We should optimize
// which pages are lazy loaded in the future.
const Contact = lazy(() => import('./pages/Contact'));
const Index = lazy(() => import('./pages/Index'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Projects = lazy(() => import('./pages/Projects'));
const CampusQuest = lazy(() => import('./pages/CampusQuest'));
const Fortress = lazy(() => import('./pages/Fortress'));
const TremorTrackr = lazy(() => import('./pages/TremorTrackr'));
const ProjectNexus = lazy(() => import('./pages/ProjectNexus'));
const OptiFolio = lazy(() => import('./pages/OptiFolio'));
const Cato = lazy(() => import('./pages/Cato'));
const CausticGuard = lazy(() => import('./pages/CausticGuard'));
const TariffInsight = lazy(() => import('./pages/TariffInsight'));
const Meander = lazy(() => import('./pages/Meander'));

// const Stats = lazy(() => import('./pages/Stats'));

const App = () => (
  <BrowserRouter basename={PUBLIC_URL}>
    <Suspense fallback={<Main />}>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/projects" element={<Projects />} />
        {/* <Route path="/resume" element={<Resume />} /> */}
        <Route path="/projects/CampusQuest" element={<CampusQuest />} />
        <Route path="/projects/TremorTrackr" element={<TremorTrackr />} />
        <Route path="/projects/Fortress" element={<Fortress />} />
        <Route path="/projects/ProjectNexus" element={<ProjectNexus />} />
        <Route path="/projects/OptiFolio" element={<OptiFolio />} />
        <Route path="/projects/Cato" element={<Cato />} />
        <Route path="/projects/CausticGuard" element={<CausticGuard />} />
        <Route path="/projects/TariffInsight" element={<TariffInsight />} />
        <Route path="/projects/Meander" element={<Meander />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
    <Analytics />
  </BrowserRouter>
);

export default App;
